import { getDataset, getDatasetMedia, getFolder, getDiveConfiguration, } from 'platform/web-girder/api';
import { MultiType } from 'dive-common/constants';
const datasetModule = {
    namespaced: true,
    state: {
        meta: null,
    },
    mutations: {
        set(state, { dataset, prevNext, hierarchy }) {
            state.meta = dataset;
            if (prevNext) {
                state.prevNext = prevNext;
            }
            if (hierarchy) {
                state.hierarchy = hierarchy;
            }
        },
    },
    actions: {
        async load({ commit, dispatch }, datasetId) {
            const [folder, metaStatic, diveConfig, media] = await Promise.all([
                getFolder(datasetId),
                getDataset(datasetId),
                getDiveConfiguration(datasetId),
                getDatasetMedia(datasetId),
            ]);
            const dsMeta = {
                ...metaStatic.data,
                ...media.data,
                videoUrl: media.data.video?.url,
                overlays: media.data.overlays,
            };
            // TODO remove when multi is supported in web
            if (dsMeta.type === MultiType) {
                throw new Error('multi is not supported on web yet');
            }
            commit('set', { dataset: dsMeta, prevNext: diveConfig.data.prevNext, hierarchy: diveConfig.data.hierarchy });
            const { parentId, parentCollection } = folder.data;
            if (parentId && parentCollection) {
                dispatch('Location/hydrate', {
                    _id: parentId,
                    _modelType: parentCollection,
                }, { root: true });
            }
            else {
                throw new Error(`dataset ${datasetId} was not a valid girder folder`);
            }
            return { metadata: dsMeta, diveConfig: diveConfig.data };
        },
    },
};
export default datasetModule;
